

import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ActivationCodeRecoveryFlow from './ActivationCodeRecoveryFlow';
import TvActivationCodeRecoveryBlockData from '../../../Models/Content/TvActivationCodeRecoveryBlockData';

import { isMobile } from "react-device-detect";

export default class TvActivationCodeRecoveryBlock extends EpiComponent<TvActivationCodeRecoveryBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    if (typeof window.scrollTo === "function") { 
      window.scrollTo(0, 0);
    } 
    let cssClasses: Array<string> = ['tv-activation-code-recovery'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);
    //protected getDestinationLink() : ContentLink
    //{
    //    return this.props.data.exitFlowPage.value || this.getContext().getRoutedContent()?.contentLink;
    //}

    return (  
      <div className={cssClasses.join(" ")}>
        <ActivationCodeRecoveryFlow context={this.getContext()}   contentData={this.props.data}/>
      </div>          
    )
  }
}





